import { Descriptions } from 'antd';
import { BenefitDisplayContent } from './BenefitDisplayContent';

interface CoverageContentProps {
  items: Array<BenefitDisplayContent>;
}

const CoverageContent = ({ items }: CoverageContentProps) => {
  return (
    <Descriptions column={1} bordered>
      {items.map(({ title, value }) => {
        const hasTitle = !!title;
        return (
          <Descriptions.Item
            key={`${title}-${value}`}
            label={hasTitle ? title : value}
            labelStyle={hasTitle ? { width: '30%' } : { backgroundColor: '#fff', borderRight: 'none' }}
          >
            {hasTitle && value}
          </Descriptions.Item>
        );
      })}
    </Descriptions>
  );
};

export default CoverageContent;
